import Button, { Props as ButtonProps } from "../Button/Button";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { AnimatePresence, motion } from "framer-motion";

interface Props {
  buttonProps: ButtonProps;
  children: React.ReactNode;
}

export default function ButtonPopover({ buttonProps, children }: Props) {
  const popover = <div>{children}</div>;

  return (
    <Popover className="relative">
      {({ open }) => (
        <>
          <PopoverButton as={Button} {...buttonProps} />
          <AnimatePresence>
            {open && (
              <PopoverPanel
                as={motion.div}
                static
                anchor="bottom"
                initial={{ opacity: 0, y: 5 }}
                animate={{ opacity: 1, y: 0, transition: { duration: 0.2 } }}
                exit={{ opacity: 0, y: -5, transition: { duration: 0.1 } }}
                className={
                  "bg-black border-2 border-white rounded z-20 [--anchor-gap:8px] shadow"
                }
              >
                {popover}
              </PopoverPanel>
            )}
          </AnimatePresence>
        </>
      )}
    </Popover>
  );
}
